// extracted by mini-css-extract-plugin
export default {"primaryBox":"styles_primaryBox__2cqbd","tabList":"styles_tabList__Q4CqK"};